import { useMemo } from "react";

import { getErrorMessage } from "~/v2/api/hooks";
import { useGetBalances } from "~/v2/api/hooks/useGetBalances";
import { MARGIN_POLLING_INTERVAL } from "~/v2/constants";
import { useAccountContext } from "~/v2/providers/AccountProvider";
import { BalancesWidgetPresentation } from "./BalancesWidget.pres";
import { formatBalanceAsOf, toBalanceRows } from "./balances.utils";

export interface BalancesWidgetConnectorProps {
  id: string;
}

export const BalancesWidget = (_props: BalancesWidgetConnectorProps) => {
  const { currentAccount, product } = useAccountContext();
  const isAccountReady = Boolean(currentAccount?.id && product);

  const { data, error, isError, isFetched, isLoading, isFetching, refetch } =
    useGetBalances({
      accountID: currentAccount?.id ?? "",
      paper: product === "paper",
      options: {
        enabled: isAccountReady,
        meta: { showErrorToast: false },
        refetchInterval: MARGIN_POLLING_INTERVAL,
      },
    });

  const rows = useMemo(
    () => toBalanceRows(data?.current, data?.last),
    [data?.current, data?.last],
  );
  const isUnavailable =
    isError || (isAccountReady && isFetched && !data?.current);

  return (
    <BalancesWidgetPresentation
      rows={rows}
      previousCloseAsOf={formatBalanceAsOf(data?.last?.balance_asof)}
      isLoading={isLoading}
      isFetching={isFetching}
      isUnavailable={isUnavailable}
      errorMessage={
        error
          ? getErrorMessage(error)
          : isUnavailable
            ? "Balance data is unavailable."
            : undefined
      }
      onRetry={refetch}
      isAccountReady={isAccountReady}
    />
  );
};
